import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IconButton, Grid, Card, Tooltip } from "@material-ui/core";
import { getLocalizedString } from "@icarius-localization/strings";
import { DeleteIcon } from "@icarius-icons";
import AttachFileIcon from '@material-ui/icons/AttachFile';
import DataContainer from "@icarius-common/abmComponents/dataContainer";
import { deletePermissionTypeAction } from "@icarius-pages/issueTypesSettings/actions";
import { getDataArrays } from "@icarius-pages/issueTypesSettings/selectors";
import { openDialogAction } from "@icarius-common/dialog/actions";
import Form from "./form";

const DataItem = (props) => {

  const { data, color, closeNew } = props;
  const dispatch = useDispatch();
  const dataArrays = useSelector(getDataArrays);

  const isCreate = !Boolean(data);

  const [isOpen, setIsOpen] = useState(isCreate); //si viene sin data, que este abierto por defecto

  const handleDeletePublication = () => {
    if (isCreate) {
      closeNew();
    } else {
      dispatch(deletePermissionTypeAction(data))
    }
  }

  const handleClosePublication = () => {
    Boolean(data) && setIsOpen(prev => !prev);
  }

  const getQualificationName = () => {
    if (!dataArrays?.qualifications) return "";
    return dataArrays.qualifications.find(qualification => qualification.key === data.qualification)?.value ?? "";
  }

  // En la card de alta este boton no borra nada: handleDeletePublication cae en
  // closeNew() y descarta lo tipeado sin crear. El dialogo igual decia "borrar
  // tipo de permiso", que es enganoso, asi que en alta se confirma como cancelacion.
  const handleOpenDeleteDialog = () => {
    dispatch(openDialogAction({
      title: getLocalizedString(isCreate ? "cancel" : "deletePermissionType"),
      msg: getLocalizedString(isCreate ? "unsavedChangesConfirmation" : "wantToDeletePermissionType"),
      onConfirm: handleDeletePublication,
    }));
  }

  return (
    <>
      <Card style={{ width: "100%", borderRadius: 10, background: (isOpen || isCreate) ? color : "", color: (isOpen || isCreate) && 'white' }}>
        <Grid container item xs={12} direction="row" style={{ padding: "10px 20px" }}>
          <Grid container item xs={11} style={{ cursor: Boolean(data) ? "pointer" : "" }} onClick={handleClosePublication}>
            {
              isCreate ?
                <DataContainer lg={12} sm={12} md={12} text={getLocalizedString("createPermissionTypes")} />
                :
                <>
                  <DataContainer sm={12} md={6} lg={2} text={data.code} />
                  <DataContainer sm={12} md={6} lg={5} text={data.name} />
                  <DataContainer sm={12} md={6} lg={3} text={getQualificationName()} />
                  <DataContainer sm={12} md={6} lg={2} text={`${data.quantity}`} />
                </>
            }
          </Grid>
          <Grid container item direction="row" justify="space-between" alignItems="center" xs={1}>
            <div style={{ visibility: (!isOpen && data?.isAttachmentRequired) ? "visible" : "hidden" }}>
              <Tooltip title={getLocalizedString("mandatoryAttachment")}>
                <IconButton size={"small"} disableRipple style={{ cursor: "default" }}>
                  <AttachFileIcon style={{ fill: "var(--mainText)" }} fontSize="small" />
                </IconButton>
              </Tooltip>
            </div>
            <Tooltip title={getLocalizedString("delete")}>
              <IconButton size={"small"} disableRipple onClick={handleOpenDeleteDialog}>
                <DeleteIcon style={{ fill: "var(--mainText)" }} fontSize="small" />
              </IconButton>
            </Tooltip>
          </Grid>
        </Grid>
      </Card>
      {
        isOpen &&
        <Form data={data} dataArrays={dataArrays} handleClose={isCreate ? closeNew : handleClosePublication} />
      }
    </>
  );
}

export default DataItem;
